import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import Home from './pages/Home';
import { OrcamentoProvider } from './contexts/orcamentoContext';
import Orcamento from './pages/Orcamento';
import QuemSomos from './pages/QuemSomos';
import Faq from './pages/FAQ';
import FaleConosco from './pages/FaleConosco';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Cadastro from './pages/Cadastro';
import Curso from './pages/Curso';
import LGPD from './pages/LGPD';


function App() {
  return (
    <div className="App">
      <OrcamentoProvider>
        <BrowserRouter> 
        <ScrollToTop />
          <Header />
          <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route path="/orcamento" element={<Orcamento />}></Route>
              <Route path="/quemsomos" element={<QuemSomos />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/fale-conosco" element={<FaleConosco />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/cadastro" element={<Cadastro />} />
              <Route path="/curso" element={<Curso />} />
              <Route path="/lgpd" element={<LGPD />} /> 
              
              
          </Routes>
          <Footer />
        </BrowserRouter>
      </OrcamentoProvider>
    </div>
  );
}

export default App;